"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.LastSessionResponseToJSON = exports.LastSessionResponseFromJSONTyped = exports.LastSessionResponseFromJSON = void 0;
var runtime_1 = require("../runtime");
var _1 = require("./");
function LastSessionResponseFromJSON(json) {
    return LastSessionResponseFromJSONTyped(json, false);
}
exports.LastSessionResponseFromJSON = LastSessionResponseFromJSON;
function LastSessionResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'lastSession': !(0, runtime_1.exists)(json, 'lastSession') ? undefined : (0, _1.SessionInfoFromJSON)(json['lastSession']),
        'recentSessions': !(0, runtime_1.exists)(json, 'recentSessions') ? undefined : (json['recentSessions'].map(_1.RecentSessionFromJSON)),
        'todaySummary': !(0, runtime_1.exists)(json, 'todaySummary') ? undefined : (0, _1.LastSessionResponseTodaySummaryFromJSON)(json['todaySummary']),
    };
}
exports.LastSessionResponseFromJSONTyped = LastSessionResponseFromJSONTyped;
function LastSessionResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'lastSession': (0, _1.SessionInfoToJSON)(value.lastSession),
        'recentSessions': value.recentSessions === undefined ? undefined : (value.recentSessions.map(_1.RecentSessionToJSON)),
        'todaySummary': (0, _1.LastSessionResponseTodaySummaryToJSON)(value.todaySummary),
    };
}
exports.LastSessionResponseToJSON = LastSessionResponseToJSON;
